/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

class Static extends React.Component {
    render() {
        const { url } = this.props;
        return (
            <iframe className="static-container" frameBorder="0" src={url} />
        );
    }
}

const propTypes = {
    url: PropTypes.string.isRequired,
};

Static.propTypes = propTypes;

export default Static;
